import { getLocationId } from '~/utils/location';

const DEFAULT_LOCATIONS_CONTENT_S3_URL = 'https://content.tour.seenic.io';

function readEnv(...keys) {
  for (const key of keys) {
    const value = process.env[key];
    if (value) {
      return value;
    }
  }
  return '';
}

export const locationsContentBaseUrl = () =>
  String(
    readEnv('LOCATIONS_CONTENT_S3_URL') || DEFAULT_LOCATIONS_CONTENT_S3_URL,
  ).replace(/\/$/, '');

const tourMediaBaseUrl = () =>
  String(readEnv('TOUR_API_URL')).replace(/\/$/, '');
export function getVirtualTourCubePreviewUrl(locationId, startPoint) {
  const pointId = startPoint ?? 1;
  return `${locationsContentBaseUrl()}/locations/${locationId}/model/cube/${pointId}_cubefront_0-0-0.jpg`;
}

export function getVirtualTourBrandingPreviewUrl(locationId) {
  return `${tourMediaBaseUrl()}/media/locations/${locationId}/preview.jpg`;
}

export function getVirtualTourPreviewUrl(params) {
  if (params.requireProcessing) {
    return undefined;
  }

  if (params.usePreview) {
    return getVirtualTourBrandingPreviewUrl(params.locationId);
  }

  return getVirtualTourCubePreviewUrl(params.locationId, params.startPoint);
}

export function getExplorerPreviewUrl(params) {
  if (params.overviewTour) {
    return getVirtualTourPreviewUrl(params.overviewTour);
  }

  const locationId = Number(params.overviewLocation);
  if (!Number.isFinite(locationId) || locationId <= 0) {
    return undefined;
  }

  return getVirtualTourPreviewUrl({ locationId, startPoint: 1 });
}

export function getLocationPreviewUrl(locationOrId) {
  if (
    typeof locationOrId === 'number' ||
    (typeof locationOrId === 'string' && locationOrId !== '')
  ) {
    const locationId = Number(locationOrId);
    if (!Number.isFinite(locationId) || locationId <= 0) {
      return undefined;
    }
    return getVirtualTourPreviewUrl({ locationId, startPoint: 1 });
  }

  const locationId = Number(locationOrId?.id ?? locationOrId?.location_id);
  if (!Number.isFinite(locationId) || locationId <= 0) {
    return undefined;
  }

  return getVirtualTourPreviewUrl({
    locationId,
    usePreview: locationOrId?.usePreview ?? locationOrId?.use_preview,
    requireProcessing:
      locationOrId?.requireProcessing ?? locationOrId?.require_processing,
    startPoint: locationOrId?.startPoint ?? locationOrId?.start_point ?? 1,
  });
}

export function getPropertyPreviewUrl(property) {
  const locations = property?.locations;
  if (locations?.length > 0) {
    return getLocationPreviewUrl(locations[0]);
  }

  const explorer = property?.explorers3D?.[0];
  if (!explorer) {
    return undefined;
  }

  const overviewLocationId = Number(explorer.settings?.overviewLocation);
  const overviewLocation = Number.isFinite(overviewLocationId)
    ? locations?.find(
        location => Number(getLocationId(location)) === overviewLocationId,
      )
    : undefined;

  return getExplorerPreviewUrl({
    overviewLocation: explorer.settings?.overviewLocation,
    overviewTour: overviewLocation
      ? {
          locationId: Number(getLocationId(overviewLocation)),
          usePreview:
            overviewLocation.usePreview ?? overviewLocation.use_preview,
          requireProcessing:
            overviewLocation.requireProcessing ??
            overviewLocation.require_processing,
          startPoint:
            overviewLocation.startPoint ?? overviewLocation.start_point ?? 1,
        }
      : null,
  });
}
